// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28ToC","controls":"styles_controls__2KgwM","charLimit":"styles_charLimit__2F_R4","input":"styles_input__2n7uP","send":"styles_send__3A8UP"};